import { render } from "./Badge.vue?vue&type=template&id=7f6ae342"
const script = {}

import "./Badge.vue?vue&type=style&index=0&id=7f6ae342&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__